export const courseFees = [
  {
    course_name: "DCA+",
    total_fee: 13900,
    one_time_fee: 13500,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 3500, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 4,
      },
      {
        component_type: "Monthly Fee",
        amount: 1700,
        frequency: "Monthly",
        order: 5,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 6,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 7,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 8,
      },
      {
        component_type: "Monthly Fee",
        amount: 1700,
        frequency: "Monthly",
        order: 9,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 10,
      },
    ],
  },
  {
    course_name: "CCC",
    total_fee: 4400,
    one_time_fee: 4000,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 2200, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 2200,
        frequency: "Monthly",
        order: 2,
      },
    ],
  },
  {
    course_name: "O-Level",
    total_fee: 22700,
    one_time_fee: 21700,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 3500, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 3200,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 4,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 5,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 6,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 7,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 8,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 9,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 10,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 11,
      },
      {
        component_type: "Monthly Fee",
        amount: 1600,
        frequency: "Monthly",
        order: 12,
      },
    ],
  },
  {
    course_name: "ADCA",
    total_fee: 12000,
    one_time_fee: 11500,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 3500, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 4,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 5,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 6,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 7,
      },
      {
        component_type: "Monthly Fee",
        amount: 1500,
        frequency: "Monthly",
        order: 8,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 9,
      },
    ],
  },
  {
    course_name: "DFA",
    total_fee: 10500,
    one_time_fee: 10000,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 3500, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 4,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 5,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 6,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 7,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 8,
      },
    ],
  },
  {
    course_name: "CCO",
    total_fee: 5000,
    one_time_fee: 4500,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 1500, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 1500,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 4,
      },
    ],
  },
  {
    course_name: "Typing",
    total_fee: 6000,
    one_time_fee: 5500,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 2000, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 3,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 4,
      },
      {
        component_type: "Monthly Fee",
        amount: 1000,
        frequency: "Monthly",
        order: 5,
      },
    ],
  },
  {
    course_name: "CFA PLUS",
    total_fee: 6600,
    one_time_fee: 6300,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 2200, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 2200,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 2200,
        frequency: "Monthly",
        order: 3,
      },
    ],
  },
  {
    course_name: "DTP",
    total_fee: 6000,
    one_time_fee: 5700,
    fee_breakdown: [
      { component_type: "Enrollment Fee", amount: 2000, order: 1 },
      {
        component_type: "Monthly Fee",
        amount: 2000,
        frequency: "Monthly",
        order: 2,
      },
      {
        component_type: "Monthly Fee",
        amount: 2000,
        frequency: "Monthly",
        order: 3,
      },
    ],
  },
];
